import { PagesService } from "@/common/api.service"
import { FETCH_PAGES, FETCH_INDIVIDUAL_PAGE,PAGES_RESET_STATE } from "./actions.type"
import { SET_PAGES, SET_INDIVIDUAL_PAGE,RESET_PAGES_STATE } from "./mutations.type"

const initialState = () => {
    return {
        pagesdata: [],
        individualpage:[]
    }
}

let state = initialState()

const getters = {
    pagesdata(state) {
        return state.pagesdata
    },
    individualpage(state) {
        return state.individualpage
    }    
}

const actions = {
    async [FETCH_PAGES](context, slug) {
        const { data } = await PagesService.get(slug)
        context.commit(SET_PAGES, data.data)
        return data;
    },
    async [FETCH_INDIVIDUAL_PAGE](context, slug) {
        const { data } = await PagesService.get(slug)
        context.commit(SET_INDIVIDUAL_PAGE, data.data)
        return data;
    },    
    [PAGES_RESET_STATE]({ commit }) {
        commit(RESET_PAGES_STATE);
    }
}

const mutations = {
    [SET_PAGES](state, pagedata) {
        state.pagesdata = pagedata
    },
    [SET_INDIVIDUAL_PAGE](state, individualpagedata) {
        state.individualpage = individualpagedata
    },    
    [RESET_PAGES_STATE](state) {
        state.individualpage = []
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};